export default "__VITE_ASSET__CwdAJeGA__"